export default __webpack_public_path__ + "static/media/forwardArrow.4847ba21.svg";